module.exports = __webpack_public_path__ + "static/ComposerV-ae2c8718246f3167719a3d5dc6ab808a.png";